export { CompetitorComparison } from "./CompetitorComparison";
export type { CompetitorComparisonProps } from "./CompetitorComparison";
